<ng-template #languageItemTemplate let-item="item">
  {{ item.name }}
</ng-template>

<ng-template #languageSelectionTemplate let-selection="selection">
  {{ selection[0].name }}
</ng-template>

<ng-container *ngIf="isReadonly; then readonlyContent; else editableContent"></ng-container>

<ng-template #readonlyContent>
  <div [class]="cssClass">
    <div class="row m-0 align-items-center full-height">
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">{{ '::Language' | abpLocalization }}</label>
      </div>

      <div class="col-auto">
        <label style="margin-bottom: 0px !important">{{ payload.operator | operator }}</label>
      </div>
      <div class="col-auto" [attr.title]="languageNameList">
        <span *ngIf="loading">{{ 'CA::Loading' | abpLocalization }}...</span>
        <span *ngIf="!loading">{{ selectedLanguageNames }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #editableContent>
  <div [class]="cssClass">
    <div showButtonsOnHover class="row m-0 align-items-center full-height">
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">{{ '::Language' | abpLocalization }}</label>
      </div>

      <div class="col-auto">
        <select
          class="form-select form-select-sm"
          [(ngModel)]="payload.operator"
          (ngModelChange)="operatorChanged()">
          <option *ngFor="let operator of node.categoryItem.operators" [value]="operator">
            {{ operator | operator }}
          </option>
        </select>
      </div>
      <div class="col-auto" [formGroup]="languageForm">
        <ca-select
          id="languageSelector"
          formControlName="language"
          [clearable]="true"
          [searchable]="true"
          [multiple]="true"
          [closeOnSelect]="false"
          placeholder="{{ 'CA::PleaseSelectWithThreeDots' | abpLocalization }}"
          style="width: 350px">
          <ca-option *ngFor="let language of languages" [value]="language.id">
            {{ 'Settings::Call.Language.' + language.name | abpLocalization }}
          </ca-option>
        </ca-select>
      </div>

      <div style="gap: 8px" class="col-auto d-flex flex-row justify-content-center">
        <ca-query-builder-node-duplicate-button
          (buttonClick)="onClickDuplicate($event)"></ca-query-builder-node-duplicate-button>
        <ca-query-builder-node-remove-button
          (buttonClick)="removeNode($event)"></ca-query-builder-node-remove-button>
      </div>
    </div>
  </div>
</ng-template>
